// the typescript is dodgy here... the values are defined as number | undefined but
// they transit as strings when plucked from the form, so we have to be careful
const validate = (fromRaw: number | undefined, toRaw: number | undefined) => {
    if (!fromRaw && !toRaw) {
        return 'This field is required';
    }

    const from = Number(fromRaw);
    const to = Number(toRaw);

    if (!isNaN(from) && !!fromRaw && from < 0) {
        return 'These fields must be valid numbers greater than or equal to 0';
    }

    if (!isNaN(to) && !!toRaw && to < 0) {
        return 'These fields must be valid numbers greater than or equal to 0';
    }

    if (fromRaw && toRaw && from > to) {
        return 'Max value must be more than min value';
    }

    return undefined;
};

export const rangeInputGroupHelper = {
    validate,
};
